import "@babel/polyfill";
import "jquery";

const componentRequireContext = require.context("../../../engines/portal/src", true);
const ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
